import styled from '@emotion/styled'
import { useCallback, useEffect, useState } from 'react'
import { AiOutlineShoppingCart } from 'react-icons/ai'
import { useHistory } from 'react-router'
import CoinFormatter from '../../../../components/CoinFormatter'
import Button from '../../../../components/common/Button'
import Image from '../../../../components/common/Image'
import Text from '../../../../components/common/Text'
import PriceFormatter from '../../../../components/PriceFormatter'
import StarRating from '../../../../components/StarRating'
import { SHOP_PRIMARY, WHITE } from '../../../../constant/colors'
import * as paths from '../../../../constant/path'
import { useAddProductToCart } from '../../../../services/cart/cart-query'
import { useFetchShopProductList } from '../../../../services/shop/shop-query'
import { ProductDetial } from '../../../../services/shop/shop-typed'
import { mobile } from '../../../../utils/responsive-helper'

const Layout = styled.div``

const Section = styled.div`
  margin: 16px 0;
`

const HeaderStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const ProductListLayout = styled.div`
  display: flex;
  flex-flow: row wrap;
  position: relative;
`

const ProductCardStyle = styled.div`
  margin: 4px;
  padding: 8px;
  flex: 0 1 calc(20% - 8px);
  width: calc(20% - 8px);
  background-color: ${WHITE};
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${mobile} {
    width: calc(50% - 8px);
    margin: 4px;
    padding: 8px;
    flex: 0 1 calc(50% - 8px);
  }
`

const ProductImageStyle = styled(Image)`
  height: 180px;
  max-width: 100%;
  display: block;
  margin: auto;
  padding-bottom: 8px;
`

const ProductPriceStyle = styled.div`
  display: flex;
  align-item: center;
  justify-content: space-between;
`

const AddCartStyle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  padding-top: 4px;
`

const AddCartButton = styled(Button)`
  width: 32px;
  height: 32px;
  margin-left: 4px;
  border: none;
  z-index: 100;
`

const AddCartText = styled(Text)`
  display: flex;
  color: ${WHITE};
  padding: 8px;
`

const LoadMoreLayout = styled.div`
  display: flex;
  justify-content: center;
  padding: 16px 0;
`

type ProductListProps = {
  isMobile: boolean
}

const ProductList = (props: ProductListProps) => {
  const { isMobile } = props
  const history = useHistory()
  const {
    data: productList,
    fetchNextPage,
    hasNextPage,
  } = useFetchShopProductList(isMobile ? 10 : 20)
  const [product, setProduct] = useState<ProductDetial[]>([])
  const { mutate: addProductToCart } = useAddProductToCart()

  const handleLoadMore = () => {
    fetchNextPage()
  }

  const setNewProductList = useCallback(() => {
    let newProduct: ProductDetial[] = []

    productList?.pages?.map((data) =>
      data?.content?.map((content) => (newProduct = [...newProduct, content])),
    )

    return newProduct
  }, [productList?.pages])

  useEffect(() => {
    if (productList) {
      setProduct(setNewProductList())
    }
  }, [productList, setNewProductList])

  useEffect(() => {
    if (productList?.pages) {
      setProduct(setNewProductList())
    } else {
      fetchNextPage()
    }
  }, [productList?.pages, setNewProductList, fetchNextPage])

  const handleNavigation = (productId: number) => {
    history.push(
      paths.productDetail({
        routeParam: {
          productId,
        },
        queryParam: {
          page: paths.shop(),
        },
      }),
    )
  }

  const handleAddProductInCart = (productId: number, e: any) => {
    addProductToCart({
      productId,
      quantity: 1,
    })
    e.stopPropagation()
  }

  return (
    <Layout>
      {product && (
        <Section>
          <HeaderStyled>
            <Text size={isMobile ? 24 : 32} type="SemiBold">
              สินค้าทั้งหมด
            </Text>
          </HeaderStyled>
          <ProductListLayout>
            {product?.map((data, index) => {
              return (
                <ProductCardStyle key={index} onClick={() => handleNavigation(data.id)}>
                  <div>
                    <ProductImageStyle src={data.thumbnailImage} />
                    <ProductPriceStyle>
                      <div>
                        {data?.normalCoin !== 0 && (
                          <PriceFormatter
                            fontSize={14}
                            priceType="additional"
                            value={data.normalCoin}
                          />
                        )}
                        <PriceFormatter
                          fontSize={isMobile ? 24 : 28}
                          lineHeight={isMobile ? 28 : 32}
                          priceType="display"
                          value={data?.specialCoin}
                        />
                      </div>
                      <CoinFormatter textSize={isMobile ? 14 : 18} value={data?.specialCoin} />
                    </ProductPriceStyle>
                    <Text size={18}>{data.name}</Text>
                  </div>
                  <AddCartStyle>
                    <StarRating rating={data?.rating} />
                    <AddCartButton onClick={(e) => handleAddProductInCart(data.id, e)}>
                      <AddCartText>
                        <AiOutlineShoppingCart />
                      </AddCartText>
                    </AddCartButton>
                  </AddCartStyle>
                </ProductCardStyle>
              )
            })}
          </ProductListLayout>
          <LoadMoreLayout>
            {hasNextPage && (
              <Button
                fontColor={SHOP_PRIMARY}
                style={{
                  background: 'transparent',
                  marginRight: 8,
                  borderColor: SHOP_PRIMARY,
                  borderRadius: 100,
                }}
                onClick={handleLoadMore}
              >
                โหลดเพิ่ม
              </Button>
            )}
          </LoadMoreLayout>
        </Section>
      )}
    </Layout>
  )
}

export default ProductList
